import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

class ResetPasswordForm extends Component
{
	state = {
		email: "",
		submitting: false,
		errors: [],
		successes: [],
		saved: false
	}

	constructor (props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
	}

	onSubmit (e) {
		const that = this;

		e.preventDefault();

		this.setState({ submitting: true });
		
		if (this.props.onSubmit) {
			let submitted = this.props.onSubmit(this.state.email);
			if (submitted) {
				submitted
					.then((successes) => that.setState({ successes: successes }))
					.catch((errors) => that.setState({ errors: errors }))
					.finally(() => that.setState({ submitting: false, saved: true }));
			}
		}
	}

	inputClass (input) {
		if (input in this.state.errors) {
			return "is-danger";
		}

		return "";
	}

	inputState (input) {
		if (input in this.state.errors) {
			return (
				<p className="help is-danger">{this.state.errors[input]}</p>
			);
		} else if (input in this.state.successes) {
			return (
				<p className="help is-success">{this.state.successes[input]}</p>
			);
		}

		return "";
	}

	render () {
		return (
			<form onSubmit={this.onSubmit}>
				<div className="field">
					<label className="label">E-Mail Address</label>
					<div className="control has-icons-left">
						<input 
							required 
							type="input" 
							name="email" 
							className="input {this.inputClass('email')}" 
							type="email" 
							placeholder="your@email.com"
							onChange={(e) => { this.setState({ email: e.target.value })}}
						/>
				    <span className="icon is-small is-left">
				    	<FontAwesomeIcon icon="envelope" />
				    </span>
				    {this.inputState('email')}
					</div>
				</div>
				<div className="field has-text-centered">
					<input disabled={this.state.submitting || this.state.saved} type="submit" className="button" defaultValue="Reset Password" />
					{this.inputState('credentials')}
				</div>
			</form>
		);
	}
}

export default ResetPasswordForm;


// WEBPACK FOOTER //
// ./src/Components/ResetPasswordForm.js